module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-img5.3a9cbe7f.png";